<template>
    <div class="item-line-skin">
        <div class="item-line-skin__block">
            <div class="item-line-skin-block__title" v-if="selectedPropertyObject.propertyName.length > 0">
                <h3>{{ selectedPropertyObject.groupName }} - {{ selectedPropertyObject.propertyName }}</h3>
                
                <small v-if="getDiagnostic.selectedCircle.index || getDiagnostic.selectedCircle.index == 0">
                    {{ getDiagnostic.arrayCircles[getDiagnostic.selectedCircle.index].name }}
                </small>
            </div>
            
            <h3 v-else>Выберите показатель...</h3>
        </div>

        <div class="item-line-skin__svg">
            <svg width="250" height="526" viewBox="60 0 200 526" fill="none">
                <rect x="84" width="158.792" height="526" fill="url(#pattern0)"/>

                <g
                    v-for="(element, index) in getDiagnostic.arrayCircles"
                    :key="'A'+index"
                    class="circle"
                    @mousemove="eventMousemove(element)"
                    @mouseleave="eventMouseleave(element)"
                    @click="clickCircle(element, index)"
                >
                    <circle
                        v-for="(item, key) in element.array"
                        :key="'B'+key"
                        v-show="view"
                        :cx="item.cx"
                        :cy="item.cy"
                        :r="calculateRadius(element, item, key, index)"
                        :fill="item.fill"
                    />
                </g>

                <defs>
                    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlink:href="#image0_3442_37038" transform="matrix(0.00396825 0 0 0.00119796 0 -0.000748718)"/>
                    </pattern>
                    <image id="image0_3442_37038" width="252" height="836" :xlink:href="selectedPropertyObject.viewImage ? imageNotClickBase64 : imageClickBase64"/>
                </defs>
            </svg>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import image from './imageBase64.json'

export default {
    props: {
        selectedPropertyObject: { type: Object, default: () => ({ groupName: '', propertyName: '', viewImage: false }) },
    },
    data: () => ({
        imageNotClickBase64: image.imageNotClickBase64,
        imageClickBase64: image.imageClickBase64,
    }),
    computed: {
        ...mapGetters({
            getDiagnostic: 'createDiagnosticTest/getDiagnostic',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly'
        }),
        view() {
            return this.selectedPropertyObject.viewImage
        }
    },
    methods: {
        ...mapMutations({
            changeSelectedCircle: 'createDiagnosticTest/changeSelectedCircle',
            changeFlagMedia: 'createDiagnosticTest/changeFlagMedia'
        }),
        calculateRadius(el, item, key, index) {
            if(this.getFlagReadonly) {
                if(el.files.length > 0) {
                    if(key === 0) return item.r + 6
                    else return item.r + 2
                }

                return;
            }
            
            if(el.hover || el.files.length > 0) {
                if(key === 0) return item.r + 6
                else return item.r + 2
            }

            return item.r
        },
        eventMousemove(element) {
            if(element.hover) return;
            element.hover = true;
            // console.log('eventMousemove', element.hover);
        },
        eventMouseleave(element) {
            element.hover = false;
            // console.log('eventMouseleave', element.hover);
        },
        clickCircle(element, index) {
            this.changeSelectedCircle({ element, index });
            this.changeFlagMedia(true);
        }
    }
}
</script>

<style lang="scss">
.item-line-skin {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    gap: 20px;

    &__block {
        display: flex;
        justify-content: center;
        min-height: 60px;
        width: 100%;

        &__title {
            word-break: break-all;
        }
    }

    &__svg {
        display: flex;
        justify-content: center;
        width: 100%;
    }
}
.circle {
    cursor: pointer !important;
}
</style>